const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Digits only, optional leading + for country code. */
function phoneDigits(phone: string): string {
  const trimmed = phone.trim();
  if (trimmed.startsWith('+')) {
    return `+${trimmed.slice(1).replace(/\D/g, '')}`;
  }
  return trimmed.replace(/\D/g, '');
}

export function isValidEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email.trim());
}

export function isValidMobileNumber(phone: string): boolean {
  const normalized = phoneDigits(phone);
  if (!normalized) return false;
  if (normalized.startsWith('+')) {
    const digits = normalized.slice(1);
    return digits.length >= 10 && digits.length <= 15;
  }
  return normalized.length >= 10 && normalized.length <= 15;
}

export interface StaffContactFieldErrors {
  messages: string[];
  email?: string;
  phone?: string;
}

export function validateStaffContactFields(email: string, phone: string): StaffContactFieldErrors {
  const emailTrim = email.trim();
  const phoneTrim = phone.trim();
  const messages: string[] = [];
  let emailError: string | undefined;
  let phoneError: string | undefined;

  if (!emailTrim && !phoneTrim) {
    const message = 'Email or mobile number is required.';
    messages.push(message);
    emailError = message;
    phoneError = message;
    return { messages, email: emailError, phone: phoneError };
  }

  if (emailTrim && !isValidEmail(emailTrim)) {
    emailError = 'Enter a valid email address.';
    messages.push(emailError);
  }

  if (phoneTrim && !isValidMobileNumber(phoneTrim)) {
    phoneError = 'Enter a valid mobile number (10–15 digits, optional + country code).';
    messages.push(phoneError);
  }

  return { messages, email: emailError, phone: phoneError };
}
